<template>
  <v-list>
    <v-list-item @mouseenter="handleHighlight(feature, f)" @mouseleave="clearHighlight" dense v-for="(feature, f) in RESULTS[LAYER].features" :key="f"
                 @click="selectFeature(f)">
      <v-list-item-title>{{ getItemTitle(feature, f) }}</v-list-item-title>
    </v-list-item>

  </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { GeoJSON } from 'ol/format';

export default {
  name: 'ObjectList',

  computed: {
    ...mapGetters({
      CONFIG: 'CONFIG',
      LAYERS: 'layers/LAYERS'
    }),
    ...mapState('featureInfo', {
      RESULTS: 'results',
      LAYER: 'selectedLayer',
    }),
    LAYER_ID() {
      return this.RESULTS[this.LAYER].features[this.LAYER].id.split('.')[0];
    },
  },

  data() {
    return {};
  },

  methods: {
    clearHighlight(){
      let layer = this.$MAP.getLayerByID('info-highlight');
      layer.getSource().clear();
    },
    handleHighlight (feature, f) {
      console.log(feature, this.LAYER)
      const format = new GeoJSON();
      const gj = feature;
      let layer = this.$MAP.getLayerByID('info-highlight');

      let featureFromGeojson = format.readFeature(gj, {
        featureProjection: this.$MAP.getView().getProjection().getCode(),
        dataProjection: `EPSG:${this.$store.getters.GET_LAYERS[this.LAYER_ID].epsg}`
      });
      console.log(`EPSG:${this.$store.getters.GET_LAYERS[this.LAYER_ID].epsg}`)
      console.dir(featureFromGeojson)
      console.log(featureFromGeojson.getGeometry().getCoordinates())
      layer.getSource().addFeature(featureFromGeojson);
      console.dir(layer)
    },
    getItemTitle(feature, idx) {
      if (!this.CONFIG.config.useFirstColumnAsTitle) {
        return idx + 1;
      } else {
        const layerID = feature.id.split('.')[0];
        return feature.properties[this.LAYERS[layerID].colparams[0].name] || idx + 1;
      }
    },
    selectFeature(idx) {
      this.$store.commit('featureInfo/SELECT_QUERY_FEATURE', idx);
    },
  },
};
</script>

<style scoped>
</style>
